import { render, staticRenderFns } from "./OrderingForm.vue?vue&type=template&id=a2f3cd28&"
import script from "./OrderingForm.vue?vue&type=script&lang=ts&"
export * from "./OrderingForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports